import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages } from '../utility/getTemplateData'

let messages = localsMessages('common/orLine')

class OrLineComponent extends React.Component {

	render () {
		let orLabel = messages.label && messages.label.or

		return (
			<div className="donate_or_linner center-block">
				<div className="donate_inline">
					<p className="or_line"></p>
				</div>
				<div className="donate_inline center_or">
					<span className="donate_or_text" id="OrLineTxt" style={{ fontFamily: 'pp-sans-big-regular' }}>{orLabel}</span>
				</div>
				<div className="donate_inline"><p className="or_line"></p></div>
			</div>
		);
	}
}

OrLineComponent.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.string
};

export default OrLineComponent



// WEBPACK FOOTER //
// ./components/orLine.js